<template>
  <div id="tabbar">
    <ul>
        <li v-for="(item,index) in tabbar" :key="index" :class="tabbarIndex==index?'on':''" @click="changeRouter(item.router)">
            <div><img :src="item.icon" alt=""></div>
            <p>{{item.name}}</p>
        </li>
    </ul>
  </div>
</template>

<script>
    export default {
        name:"tabbar",
        props:{
            tabbarIndex: {
                type: Number,
                default:0,
            }
        },
        data(){
            return {
                tabbar:[
                    {
                        icon:require("@/assets/icon1.png"),
                        name:"主页",
                        router:"/liangyun/home",
                    },
                    {
                        icon:require("@/assets/icon2.png"),
                        name:"用户管理",
                        router:"/liangyun/user",
                    },
                ]
            }
        },
        created() {
          this.$store.dispatch('permission/GenerateRoutes').then(() => {
            // 根据roles权限生成可访问的路由表
            this.tabbar = this.filterPermission();
          })

        },
      methods:{
            changeRouter(router){
                if(this.$route.path!=router){
                    this.$router.push(router)
                }
            },
            filterPermission() {
              let result = [];
              let supportRoutes = Object.assign([], this.tabbar);
              let permissionRoutes = this.$store.getters.sidebarRouters;
              for (let i = 0; i < supportRoutes.length; i++) {
                let sRoute = supportRoutes[i];
                for (let j = 0; j < permissionRoutes.length; j++) {
                  let pRoute = permissionRoutes[j];
                  if (sRoute.router == pRoute.path) {
                    result.push(sRoute);
                  }
                }
              }
              return result;
            }
        }
    }
</script>

<style lang="less">
    #tabbar{
        margin-right: 20px;
        li{
            width: 170px;
            opacity: 1;
            border-radius: 40px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(239, 238, 235, 1);
            box-shadow: 6px 6px 21px  rgba(0, 0, 0, 0.05);
            display: flex;
            align-items: center;
            padding: 12px 24px 9px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(12, 12, 13, 1);
            margin-bottom: 28px;
            cursor: pointer;
            div{
                width: 24px;
                display: flex;
                align-items: center;
                margin-right: 16px;
                img{
                    width: 20px;
                }
            }
        }
        .on{
            background: rgba(229, 229, 229, 1);
            border: 1px solid rgba(239, 238, 235, 1);
            box-shadow: 6px 6px 21px  rgba(0, 0, 0, 0.05);
        }
    }
</style>
